import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import SendIcon from "@mui/icons-material/Send";
import DraftsIcon from "@mui/icons-material/Drafts";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CallIcon from "@mui/icons-material/Call";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ApartmentIcon from "@mui/icons-material/Apartment";
import InventoryIcon from "@mui/icons-material/Inventory";
import SettingsIcon from "@mui/icons-material/Settings";
import NotesIcon from "@mui/icons-material/Notes";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import ArchiveIcon from "@mui/icons-material/Archive";
import OutboxIcon from "@mui/icons-material/Outbox";
import AvTimerIcon from "@mui/icons-material/AvTimer";
import CampaignIcon from "@mui/icons-material/Campaign";
import CameraIcon from "@mui/icons-material/Camera";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import MessageIcon from "@mui/icons-material/Message";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";

import HailIcon from "@mui/icons-material/Hail";
import BallotIcon from "@mui/icons-material/Ballot";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import HandshakeIcon from "@mui/icons-material/Handshake";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AdjustIcon from "@mui/icons-material/Adjust";
import LoopIcon from "@mui/icons-material/Loop";
import AssessmentIcon from "@mui/icons-material/Assessment";
// import Diversity3Icon from "@mui/icons-material/Diversity3";
// import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import Groups2Icon from "@mui/icons-material/Groups2";
import StarsIcon from "@mui/icons-material/Stars";
// import SummarizeIcon from "@mui/icons-material/Summarize";
// import ContactPageIcon from "@mui/icons-material/ContactPage";
// import HomeWorkIcon from "@mui/icons-material/HomeWork";
// import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import QueueIcon from "@mui/icons-material/Queue";
import PaidIcon from "@mui/icons-material/Paid";
import WorkIcon from "@mui/icons-material/Work";
import SellIcon from "@mui/icons-material/Sell";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import HistoryIcon from "@mui/icons-material/History";
import WorkOffIcon from "@mui/icons-material/WorkOff";
import TimelineIcon from "@mui/icons-material/Timeline";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import SpeedIcon from "@mui/icons-material/Speed";

export const AdminSideBarData = [
  {
    name: "Dashboard",
    RoleName: "Dashboard",
    path: "/dashboard",
    icon: <DashboardIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Leads",
    RoleName: "Leads",
    path: "/leads",
    icon: <LeaderboardIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Leads",
        RoleName: "Leads",
        path: "/leads",
        icon: <LeaderboardIcon fontSize="small" />,
      },
      {
        name: "Public Leads",
        RoleName: "Leads_Public Leads",
        path: "/publicleads",
        icon: <HailIcon fontSize="small" />,
      },
      {
        name: "Recycle Leads",
        RoleName: "Leads_Recycle",
        path: "/recycle-leads",
        icon: <LoopIcon fontSize="small" />,
      },
      {
        name: "Transfer Leads",
        RoleName: "Leads_Transfer",
        path: "/TransferLeads",
        icon: <SwapHorizIcon fontSize="small" />,
      },
    ],
  },
  // {
  //   name: "Quotes",
  //   RoleName: "Quotes",
  //   path: "/quotes",
  //   icon: <NotesIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //   iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
  //   iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
  //   subitems: [],
  // },
  // {
  //   name: "Email",
  //   RoleName: "Mail",
  //   path: "/email/compose",
  //   icon: <AttachEmailIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //   iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }}/>,
  //   iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }}/>,
  //   subitems: [
  //     {
  //       name: "Compose",
  //       RoleName: "Mail",
  //       path: "/email/compose",
  //       icon: <AttachmentIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //     },
  //     {
  //       name: "Inbox",
  //       RoleName: "Mail_Inbox",
  //       path: "/email/inbox",
  //       icon: <ArchiveIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //     },
  //     {
  //       name: "Draft",
  //       RoleName: "Mail_Draft",
  //       path: "/email/draft",
  //       icon: <DraftsIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //     },
  //     {
  //       name: "OutBox",
  //       RoleName: "Mail_OutBox",
  //       path: "/email/outbox",
  //       icon: <OutboxIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //     },
  //     {
  //       name: "Sent",
  //       RoleName: "Mail_Sent",
  //       path: "/email/sent",
  //       icon: <SendIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //     },
  //     {
  //       name: "Trash",
  //       RoleName: "Mail_Trash",
  //       path: "/email/trash",
  //       icon: <RestoreFromTrashIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //     },
  //   ],
  // },
  {
    name: "Activities",
    RoleName: "Activities",
    path: "/activities",
    icon: <AvTimerIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Internal Meetings",
    RoleName: "Internal Meeting",
    path: "/meetings",
    icon: <Groups2Icon fontSize="small" style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Commission",
    RoleName: "Commission",
    path: "/commission/generate_commission",
    icon: <StarsIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Generate Commission",
        RoleName: "Commission",
        path: "/commission/generate_commission",

        icon: <QueueIcon fontSize="small" />,
      },
      {
        name: "Pay Commission",
        RoleName: "Commission",
        path: "/commission/pay_commission",

        icon: <PaidIcon fontSize="small" />,
      },
    ],
  },
  {
    name: "Contacts",
    RoleName: "Contacts",
    path: "/contacts/prospects",
    icon: <CallIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Prospects",
        RoleName: "CRM-Contacts_Prospect",
        path: "/contacts/prospects",
        icon: <PeopleAltIcon fontSize="small" />,
      },
      {
        name: "Customers",
        RoleName: "Persons",
        path: "/contacts/persons",
        icon: <PeopleAltIcon fontSize="small" />,
      },
      {
        name: "Developers",
        RoleName: "Organizations",
        path: "/contacts/organizations",
        icon: <ApartmentIcon fontSize="small" />,
      },
      {
        name: "Affiliate",
        RoleName: "Contacts_Affiliates",
        path: "/contacts/affiliate",
        icon: <HandshakeIcon fontSize="small" />,
      },
    ],
  },
  // {
  //   name: "Product",
  //   RoleName: "Products",
  //   path: "/products",
  //   icon: <InventoryIcon fontSize="small" />,
  //   subitems: [],
  // },

  // {
  //   name: "Service",
  //   RoleName: "Service",
  //   path: "/service",
  //   icon: <HomeRepairServiceIcon fontSize="small" />,
  //   subitems: [],
  // },
  {
    name: "Campaign",
    RoleName: "Campaign",
    path: "/campaigns/campaign",
    icon: <CampaignIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Campaigns",
        RoleName: "Campaign_Campaigns",
        path: "/campaigns/campaign",
        icon: <CampaignIcon fontSize="small" />,
      },
      {
        name: "Templates",
        RoleName: "Campaign_Templates",
        path: "/campaigns/templates",
        icon: <CameraIcon fontSize="small" />,
      },
      {
        name: "Campaign Groups",
        RoleName: "Campaign_Campaign_Groups",
        path: "/campaigns/groups",
        icon: <GroupWorkIcon fontSize="small" />,
      },
      {
        name: "Campaign History",
        RoleName: "Campaign_History",
        path: "/campaigns/history",
        icon: <HistoryIcon fontSize="small" />,
      },
    ],
  },
  {
    name: "Socials",
    RoleName: "Socials",
    path: "/chats/facebookpage",
    icon: <MessageIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Facebook Page",
        RoleName: "Socials_Facebook",
        path: "/chats/facebookpage",
        icon: <FacebookIcon fontSize="small" />,
      },
      {
        name: "WhatsApp",
        RoleName: "Socials_Whatsapp",
        path: "/chats/whatsApp",
        icon: <WhatsAppIcon fontSize="small" />,
      },
      {
        name: "Instagram",
        RoleName: "Socials_Instagram",
        path: "/chats/instagrampage",
        icon: <InstagramIcon fontSize="small" />,
      },
    ],
  },
  {
    name: "Inventory",
    RoleName: "Inventory",
    path: "/inventory/overview",
    icon: <BallotIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Inventory Insights",
        RoleName: "Inventory_Unit",
        path: "/inventory/overview",
        icon: <DashboardIcon fontSize="small" />,
      },
      {
        name: "Units",
        RoleName: "Inventory_Unit",
        path: "/inventory/unit",
        icon: <ApartmentIcon fontSize="small" />,
      },
      {
        name: "Booked Units",
        RoleName: "Inventory_Booked Unit",
        path: "/inventory/booked-unit",
        icon: <BookmarkAddedIcon fontSize="small" />,
      },
    ],
  },
  {
    name: "Target",
    RoleName: "Target",
    path: "/target",
    icon: <TrackChangesIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Targets",
        RoleName: "Target_Targets",
        path: "/target",
        icon: <AdjustIcon fontSize="small" />,
      },
      {
        name: "Assigned Targets",
        RoleName: "Target_Assign Targets",
        path: "/assigned-target",
        icon: <AssignmentIcon fontSize="small" />,
      },
    ],
  },
  {
    name: "Reports",
    RoleName: "Reports",
    path: "/reports/user-performance",
    icon: <AssessmentIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      // {
      //   name: "User Performance",
      //   RoleName: "Reports_User Performance",
      //   path: "/reports/user-performance",
      //   icon: <PeopleAltIcon fontSize="small" />,
      // },
      // {
      //   name: "Daily Activities",
      //   RoleName: "Reports_User Performance",
      //   path: "/reports/daily-activities",
      //   icon: <PeopleAltIcon fontSize="small" />,
      // },
      // {
      //   name: "User Leads",
      //   RoleName: "Reports_User Leads",
      //   path: "/reports/user-leads",
      //   icon: <LeaderboardIcon fontSize="small" />,
      // },
      // {
      //   name: "User Activities",
      //   RoleName: "Reports_User Activities",
      //   path: "/reports/user-activity",
      //   icon: <AvTimerIcon fontSize="small" />,
      // },
      // {
      //   name: "User Won Leads",
      //   RoleName: "Reports_User Won Leads",
      //   path: "/reports/user-won-leads",
      //   icon: <EmojiEventsIcon fontSize="small" />,
      // },
      // {
      //   name: "Target Insights",
      //   RoleName: "Reports_User Won Leads",
      //   path: "/reports/target-insights",
      //   icon: <CrisisAlertIcon fontSize="small" />,
      // },
      // {
      //   name: "User Targets",
      //   RoleName: "Reports_User Targets",
      //   path: "/reports/user-targets",
      //   icon: <TrackChangesIcon fontSize="small" />,
      // },
      // {
      //   name: "Group Performance",
      //   RoleName: "Reports_Group Performance",
      //   path: "/reports/group-performance",
      //   icon: <Diversity3Icon fontSize="small" />,
      // },
      // {
      //   name: "Sales Report",
      //   RoleName: "Reports_Sales Report",
      //   path: "/reports/SaleReport",
      //   icon: <MonetizationOnIcon fontSize="small" />,
      // },
      // {
      //   name: "Profit",
      //   RoleName: "Organizations",
      //   path: "/reports/profit",
      //   icon: <AttachMoneyIcon fontSize="small" />,
      // },
      {
        name: "Sales & Pipeline Performance",
        RoleName: "CRM-Reports_Sales Performance Report",
        path: "/reports/sales-pipeline-performance",
        icon: <TimelineIcon fontSize="small" />,
      },
      {
        name: "Agent & Team Productivity",
        RoleName: "CRM-Reports_Agent Team Productivity",
        path: "/reports/agent-team-productivity-scorecard",
        icon: <SupportAgentIcon fontSize="small" />,
      },
      {
        name: "Target vs. Achievement",
        RoleName: "CRM-Reports_Target Vs Achievement",
        path: "/reports/target-vs-achievement-scorecard",
        icon: <TrackChangesIcon fontSize="small" />,
      },
      {
        name: "Deal Loss Reason Analysis",
        RoleName: "CRM-Reports_Deal Loss Reason Analysis",
        path: "/reports/deal-loss-reason-analysis",
        icon: <TrendingDownIcon fontSize="small" />,
      },
      {
        name: "Pipeline Velocity & Sales Cycle",
        RoleName: "CRM-Reports_Pipeline Velocity Sales Cycle",
        path: "/reports/pipeline-velocity",
        icon: <SpeedIcon fontSize="small" />,
      },
      {
        name: "Lead Transfer & Decay Audit",
        RoleName: "CRM-Reports_Lead Transfer Decay Audit",
        path: "/reports/lead-transfer-audit",
        icon: <SwapHorizIcon fontSize="small" />,
      },
      // {
      //   name: "Commission & Financial Ledger",
      //   RoleName: "CRM-Reports_Commission Financial Ledger",
      //   path: "/reports/commission-financial-ledger",
      //   icon: <MonetizationOnIcon fontSize="small" />,
      // },
      // {
      //   name: "Inventory Stock & Absorption",
      //   RoleName: "CRM-Reports_Inventory Stock Absorption",
      //   path: "/reports/inventory-stock-absorption",
      //   icon: <InventoryIcon fontSize="small" />,
      // },
      // {
      //   name: "Commission Dashboard",
      //   RoleName: "CRM-Reports_Commission Dashboard",
      //   path: "/reports/commission-dashboard",
      //   icon: <DashboardIcon fontSize="small" />,
      // },
    ],
  },
  // {
  //   name: "Commission Reports",
  //   RoleName: "Commission",
  //   path: "/commission-reports/CommissionSummary",
  //   icon: <FolderSpecialIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //   iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
  //   iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
  //   subitems: [
  //     {
  //       name: "Commission Summary",
  //       RoleName: "Commission Reports_Commission Summary",
  //       path: "/commission-reports/CommissionSummary",
  //       icon: <SummarizeIcon fontSize="small" />,
  //     },
  //     {
  //       name: "User Commission",
  //       RoleName: "Commission Reports_User Commission",
  //       path: "/commission-reports/user-commission",
  //       icon: <ContactPageIcon fontSize="small" />,
  //     },

  //     {
  //       name: "Project Commission",
  //       RoleName: "Commission Reports_Project Commission",
  //       path: "/commission-reports/project-commission",
  //       icon: <HomeWorkIcon fontSize="small" />,
  //     },
  //     {
  //       name: "Affiliate Performance",
  //       RoleName: "Commission Reports_Affiliate Performance",
  //       path: "/commission-reports/AffiliatePerformance",
  //       icon: <ConnectWithoutContactIcon fontSize="small" />,
  //     },
  //     {
  //       name: "Commission Trends",
  //       RoleName: "Commission Reports_Commission Trends",
  //       path: "/commission-reports/commission-trends",
  //       icon: <CalendarMonthIcon fontSize="small" />,
  //     },
  //   ],
  // },
  // {
  //   name: "Report Errors",
  //   path: "/report-errors",
  //   RoleName: "Dashboard",
  //   icon: <ReportIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //   subitems: [],
  // },
  {
    name: "Settings",
    RoleName: "Settings",
    path: "/settings",
    icon: <SettingsIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
];

export const SuperAdminSideBarData = [
  {
    name: "Businesses",
    RoleName: "Other Settings_Business",
    path: "/business",
    icon: <WorkIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Subscriptions",
    RoleName: "Settings_Subscription",
    path: "/subscription",
    icon: <DashboardIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Screens",
    RoleName: "Roles",
    path: "/screens",
    icon: <SellIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Users",
    RoleName: "Users",
    path: "/users",
    icon: <AccountBoxIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Payments",
    RoleName: "Settings_Subscription",
    path: "/payments",
    icon: <ReceiptLongIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Config Setting",
    RoleName: "Settings_Subscription",
    path: "/configsetting",
    icon: <SettingsIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Module",
    RoleName: "Users",
    path: "/module",
    icon: <ViewModuleIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Expired Business Plans",
    RoleName: "Other Settings_Business",
    path: "/expired-business-plan",
    icon: <WorkOffIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
];

export const GeneralSidebarData = [
  {
    name: "Dashboard",
    RoleName: "Dashboard",
    path: "/dashboard",
    icon: <DashboardIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Leads",
    RoleName: "Leads",
    path: "/leads",
    icon: <LeaderboardIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Leads",
        RoleName: "Leads",
        path: "/leads",
        icon: <LeaderboardIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Public Leads",
        RoleName: "Leads_Public Leads",
        path: "/publicleads",
        icon: <HailIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Recycle Leads",
        RoleName: "Leads_Recycle",
        path: "/recycle-leads",
        icon: <LoopIcon fontSize="small" />,
      },
      {
        name: "Transfer Leads",
        RoleName: "Leads_Transfer",
        path: "/TransferLeads",
        icon: <SwapHorizIcon fontSize="small" />,
      },
    ],
  },
  // {
  //   name: "Leads",
  //   RoleName: "Leads",
  //   path: "/leads",
  //   icon: <LeaderboardIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //   iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
  //   iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
  //   subitems: [],
  // },
  {
    name: "Quotes",
    RoleName: "Quotes",
    path: "/quotes",
    icon: <NotesIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Email",
    RoleName: "Mail",
    path: "/email/compose",
    icon: <AttachEmailIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Compose",
        RoleName: "Mail",
        path: "/email/compose",
        icon: <AttachmentIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Inbox",
        RoleName: "Mail_Inbox",
        path: "/email/inbox",
        icon: <ArchiveIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Draft",
        RoleName: "Mail_Draft",
        path: "/email/draft",
        icon: <DraftsIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "OutBox",
        RoleName: "Mail_OutBox",
        path: "/email/outbox",
        icon: <OutboxIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Sent",
        RoleName: "Mail_Sent",
        path: "/email/sent",
        icon: <SendIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Trash",
        RoleName: "Mail_Trash",
        path: "/email/trash",
        icon: <RestoreFromTrashIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
    ],
  },
  {
    name: "Activities",
    RoleName: "Activities",
    path: "/activities",
    icon: <AvTimerIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    subitems: [],
  },

  {
    name: "Contacts",
    RoleName: "Contacts",
    path: "/contacts/prospects",
    icon: <CallIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Prospects",
        RoleName: "CRM-Contacts_Prospect",
        path: "/contacts/prospects",
        icon: <PeopleAltIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Customers",
        RoleName: "Persons",
        path: "/contacts/persons",
        icon: <PeopleAltIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Organizations",
        RoleName: "Organizations",
        path: "/contacts/organizations",
        icon: <ApartmentIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Affiliate",
        RoleName: "Contacts_Affiliates",
        path: "/contacts/affiliate",
        icon: <HandshakeIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
    ],
  },
  {
    name: "Product",
    RoleName: "Products",
    path: "/products",
    icon: <InventoryIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    subitems: [],
  },

  {
    name: "Service",
    RoleName: "Service",
    path: "/service",
    icon: <HomeRepairServiceIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
  {
    name: "Campaign",
    RoleName: "Campaign",
    path: "/campaigns/campaign",
    icon: <CampaignIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Campaigns",
        RoleName: "Campaign_Campaigns",
        path: "/campaigns/campaign",
        icon: <CampaignIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Templates",
        RoleName: "Campaign_Templates",
        path: "/campaigns/templates",
        icon: <CameraIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Campaign Groups",
        RoleName: "Campaign_Campaign_Groups",
        path: "/campaigns/groups",
        icon: <GroupWorkIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Campaign History",
        RoleName: "Campaign_History",
        path: "/campaigns/history",
        icon: <HistoryIcon fontSize="small" />,
      },
    ],
  },
  // {
  //   name: "Socials",
  //   RoleName: "Chats",
  //   path: "/chats/facebookpage",
  //   icon: <MessageIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //   iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
  //   iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
  //   subitems: [
  //     {
  //       name: "Facebook Page",
  //       RoleName: "Chats",
  //       path: "/chats/facebookpage",
  //       icon: <FacebookIcon fontSize="small" style={{ marginBottom: "7px" }} />,
  //     },
  //   ],
  // },
  {
    name: "Socials",
    RoleName: "Socials",
    path: "/chats/facebookpage",
    icon: <MessageIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Facebook Page",
        RoleName: "Socials_Facebook",
        path: "/chats/facebookpage",
        icon: <FacebookIcon fontSize="small" />,
      },
      {
        name: "WhatsApp",
        RoleName: "Socials_Whatsapp",
        path: "/chats/whatsApp",
        icon: <WhatsAppIcon fontSize="small" />,
      },
      {
        name: "Instagram",
        RoleName: "Socials_Instagram",
        path: "/chats/instagrampage",
        icon: <InstagramIcon fontSize="small" />,
      },
    ],
  },
  {
    name: "Inventory",
    RoleName: "Inventory",
    path: "/inventory/overview",
    icon: <BallotIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Inventory Insights",
        RoleName: "Inventory_Unit",
        path: "/inventory/overview",
        icon: <DashboardIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Units",
        RoleName: "Inventory_Unit",
        path: "/inventory/unit",
        icon: <ApartmentIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
      {
        name: "Booked Units",
        RoleName: "Inventory_Booked Unit",
        path: "/inventory/booked-unit",
        icon: <BookmarkAddedIcon fontSize="small" style={{ marginBottom: "7px" }} />,
      },
    ],
  },
  {
    name: "Target",
    RoleName: "Target",
    path: "/target",
    icon: <TrackChangesIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      {
        name: "Targets",
        RoleName: "Target_Targets",
        path: "/target",
        icon: <AdjustIcon fontSize="small" />,
      },
      {
        name: "Assigned Targets",
        RoleName: "Target_Assign Targets",
        path: "/assigned-target",
        icon: <AssignmentIcon fontSize="small" />,
      },
    ],
  },
  {
    name: "Reports",
    RoleName: "Reports",
    path: "/reports/user-performance",
    icon: <AssessmentIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    iconClosed: <ArrowDropDownIcon style={{ marginBottom: "7px" }} />,
    iconOpened: <ArrowDropUpIcon style={{ marginBottom: "7px" }} />,
    subitems: [
      // {
      //   name: "User Performance",
      //   RoleName: "Reports_User Performance",
      //   path: "/reports/user-performance",
      //   icon: <PeopleAltIcon fontSize="small" />,
      // },
      // {
      //   name: "Daily Activities",
      //   RoleName: "Reports_User Performance",
      //   path: "/reports/daily-activities",
      //   icon: <PeopleAltIcon fontSize="small" />,
      // },
      // {
      //   name: "User Leads",
      //   RoleName: "Reports_User Leads",
      //   path: "/reports/user-leads",
      //   icon: <LeaderboardIcon fontSize="small" />,
      // },
      // {
      //   name: "User Activities",
      //   RoleName: "Reports_User Activities",
      //   path: "/reports/user-activity",
      //   icon: <AvTimerIcon fontSize="small" />,
      // },
      // {
      //   name: "User Won Leads",
      //   RoleName: "Reports_User Won Leads",
      //   path: "/reports/user-won-leads",
      //   icon: <EmojiEventsIcon fontSize="small" />,
      // },
      // {
      //   name: "Target Insights",
      //   RoleName: "Reports_User Won Leads",
      //   path: "/reports/target-insights",
      //   icon: <CrisisAlertIcon fontSize="small" />,
      // },
      // {
      //   name: "User Targets",
      //   RoleName: "Reports_User Targets",
      //   path: "/reports/user-targets",
      //   icon: <TrackChangesIcon fontSize="small" />,
      // },
      // {
      //   name: "Group Performance",
      //   RoleName: "Reports_Group Performance",
      //   path: "/reports/group-performance",
      //   icon: <Diversity3Icon fontSize="small" />,
      // },
      // {
      //   name: "Sales Report",
      //   RoleName: "Reports_Sales Report",
      //   path: "/reports/SaleReport",
      //   icon: <MonetizationOnIcon fontSize="small" />,
      // },
      // {
      //   name: "Profit",
      //   RoleName: "Organizations",
      //   path: "/reports/profit",
      //   icon: <AttachMoneyIcon fontSize="small" />,
      // },
      {
        name: "Sales & Pipeline Performance",
        RoleName: "CRM-Reports_Sales Performance Report",
        path: "/reports/sales-pipeline-performance",
        icon: <TimelineIcon fontSize="small" />,
      },
      {
        name: "Agent & Team Productivity",
        RoleName: "CRM-Reports_Agent Team Productivity",
        path: "/reports/agent-team-productivity-scorecard",
        icon: <SupportAgentIcon fontSize="small" />,
      },
      // {
      //   name: "Target vs. Achievement",
      //   RoleName: "CRM-Reports_Target Vs Achievement",
      //   path: "/reports/target-vs-achievement-scorecard",
      //   icon: <TrackChangesIcon fontSize="small" />,
      // },
      // {
      //   name: "Deal Loss Reason Analysis",
      //   RoleName: "CRM-Reports_Deal Loss Reason Analysis",
      //   path: "/reports/deal-loss-reason-analysis",
      //   icon: <TrendingDownIcon fontSize="small" />,
      // },
      {
        name: "Pipeline Velocity & Sales Cycle",
        RoleName: "CRM-Reports_Pipeline Velocity Sales Cycle",
        path: "/reports/pipeline-velocity",
        icon: <SpeedIcon fontSize="small" />,
      },
      {
        name: "Lead Transfer & Decay Audit",
        RoleName: "CRM-Reports_Lead Transfer Decay Audit",
        path: "/reports/lead-transfer-audit",
        icon: <SwapHorizIcon fontSize="small" />,
      },
    ],
  },
  {
    name: "Settings",
    RoleName: "Settings",
    path: "/settings",
    icon: <SettingsIcon fontSize="small" style={{ marginBottom: "7px" }} />,
    subitems: [],
  },
];
